import styled from "styled-components";

export const MyContractsStyle = styled.div`
    height: 100%;
    width: 100%;
    min-height: 100vh;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`

export const WrapContent = styled.div`
    padding: 20px;
    width: 75%;
    height: 80%;
    display: flex;
    flex-direction: column;
`

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    h1{
        color: #FF5742;
        font-size: 30px;
        font-weight: 600;
    }
`

export const SubTitle = styled.h1`
    color: black;
    font-size: 20px;
    font-weight: 500;
`

export const Button = styled.button`
  display: flex;
  width: 180px;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 15px;
  background-color: #ffc8c8; 
  color: #0056a3; 
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  
  &:hover {
    background-color: #ffb3b3; 
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 86, 163, 0.4);
  }
`;

export const ContractCard = styled.div<{ $expanded?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px;
  align-items: flex-start;
  background-color: #ffffff;
  width: 80%;
  min-height: ${({ $expanded }) => ($expanded ? "auto" : "40px")};
  height: auto;
  border-radius: 15px;
  margin-top: 20px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: min-height 0.3s ease;

  h1 {
    color: #005ca9;
    font-size: 15px;
  }
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 10px 15px;
  border-radius: 20px;
  border: 1px;
  border-style: solid;
  border-color: #FDCAC3;
  background-color: #FFFFFF;
  color: black;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
  align-self: flex-end;

  &:hover {
    background-color: #FDCAC3;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 50px;
  border-radius: 8px;
  text-align: center;
  width: 300px;
`;

export const ModalInput = styled.input`
  width: 100%;
  padding: 8px;
  height: auto;
`;

export const ModalTextarea = styled.textarea`
  width: 100%;
  padding: 8px;
  height: auto;
  min-height: 40px; 
  max-height: 200px; 
  resize: none; 
  overflow-y: hidden; 
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  gap: 80px;
  
  button {
    padding: 8px 12px;
    border: none;
    cursor: pointer;
    font-size: 16px;

    &:hover{
        background-color: #E0E0E0;
    }
  }
`;

export const RowMyContractsDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`